export class TransferOrdersService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(orders) {
    return await this.httpClient.post('/pedidos/TransferePedido', {
      NovoPDV: orders ?? []
    })
  }
}
